import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

type Props = {
  children: ReactNode
  className?: string
}

const AssignmentEntityGrid = ({ children, className }: Props) => (
  <div
    className={cn(
      'grid grid-cols-[repeat(auto-fill,minmax(min(100%,11.5rem),1fr))] gap-1',
      className,
    )}
  >
    {children}
  </div>
)

export default AssignmentEntityGrid
